import { render, staticRenderFns } from "./QQuilityTechSubmenu.vue?vue&type=template&id=4a61db0d&"
import script from "./QQuilityTechSubmenu.vue?vue&type=script&lang=js&"
export * from "./QQuilityTechSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports